export default __webpack_public_path__ + "static/media/pdf.1e041438.svg";